import { action, makeObservable, observable, reaction } from 'mobx';
import type { RoutingStore } from './RoutingStore';

export class HeaderStore {
  public isSticky: boolean = false;
  public searchCriteria: string = '';
  public isSearchInputFocused: boolean = false;

  constructor({ routingStore }: { routingStore: RoutingStore }) {
    makeObservable(this, {
      isSticky: observable,
      searchCriteria: observable,
      isSearchInputFocused: observable,
      setSearchCriteria: action,
      setIsSticky: action,
      setSearchInputFocused: action,
    });

    this.searchCriteria =
      routingStore.matchedRoute?.routeName === 'search' ? routingStore.matchedRoute?.params.criteria : '';
    this.isSearchInputFocused = this.searchCriteria === '';

    reaction(
      () => routingStore.matchedRoute,
      () => {
        const isSearchRoute = routingStore.matchedRoute?.routeName === 'search';
        if (!isSearchRoute && !this.isSearchInputFocused) {
          this.setSearchCriteria('');
        }
      },
    );
  }

  setSearchCriteria = (value: string) => {
    this.searchCriteria = value;
  };

  setIsSticky = (value: boolean) => {
    this.isSticky = value;
  };

  setSearchInputFocused = (isFocused: boolean) => {
    this.isSearchInputFocused = isFocused;
  };
}
